<template>
  <div class="be-in-trend">
    <div class="be-in-trend__header">
      <DefH2>{{ messages.beInTrend }}</DefH2>
    </div>

    <DefSlider :nav="screenWidth >= 992" :pagination="true" :settings="settings">
      <div v-for="item in result" class="swiper-slide">
        <TrendCard :result="item" :messages="messages" />
      </div>
    </DefSlider>
    <div class="be-in-trend__look">
      <DefButtonSecondary :href="messages.beautyMagazine.href">
        {{ messages.beautyMagazine.text }}
      </DefButtonSecondary>
    </div>
  </div>
</template>

<script lang="ts" setup>
import DefH2 from '@components/Def/DefH/DefH2.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import TrendCard from '@components/Trends/TrendCard.vue';
import useScreenWidth from '@use/useScreenWidth';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const props = defineProps(['result']);

const screenWidth = useScreenWidth();
const resultsStore = useResultsStore();

const messages = computed(() => resultsStore.messages);

const settings = {
  slidesPerView: 1.3,
  spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 2.3,
    },
    992: {
      slidesPerView: 3,
    },
  },
};
</script>

<style lang="scss" scoped>
.be-in-trend {
  margin-bottom: 60px;
  @include point-lg {
    margin-bottom: 80px;
  }
  &__header {
    text-align: center;
    :deep(.def-h2) {
      margin-bottom: 16px;
      @include point-lg {
        margin-bottom: 24px;
      }
    }
  }
  &__look {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    :deep(.def-button-secondary) {
      width: 100%;
      @include point-md {
        width: auto;
      }
    }
  }
  :deep(.def-slider__next) {
    right: 0;
    transform: translate(50%, -50%);
  }
  :deep(.def-slider__prev) {
    left: 0;
    transform: translate(-50%, -50%);
  }
  :deep(.trend-card) {
    height: 100%;
  }
  :deep(.swiper-wrapper) {
    padding-bottom: 10px;
  }
}
</style>
